import React from "react";
import { default as MuiCssBaseline } from "@mui/material/CssBaseline";

function CssBaseline(props) {
  return <MuiCssBaseline />;
}

export default CssBaseline;
